module.exports = __webpack_public_path__ + "static/media/contents_dougu.6d33854a.png";